window.initializeCollectionSwiper = function () {
  const swiperElements = document.querySelectorAll('[class*="swiper-collection-nav-"]');

  swiperElements.forEach((swiperEl) => {
    if (!swiperEl) return;

    // Destroy existing Swiper instance if it exists
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    let swiper = null;

    // Hide slides initially if on mobile
    if (window.innerWidth < 1024) {
      swiperEl.style.visibility = 'hidden';
    }

    function initSwiper() {
      if (window.innerWidth < 1024 && !swiper) {
        swiper = new Swiper(swiperEl, {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 12,
          freeMode: {
            enabled: true,
            sticky: false,
          },
          grabCursor: true,
          preventClicks: true,
          on: {
            init: function () {
              swiperEl.style.visibility = 'visible';
            },
            resize: function () {
              if (window.innerWidth >= 1024 && swiper) {
                swiper.destroy(true, true);
                swiper = null;
              }
            },
          },
        });
      }
    }

    initSwiper();
    window.addEventListener('resize', initSwiper);
  });
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', window.initializeCollectionSwiper);

// Initialize on section load
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.classList.contains('section--main-collection')) {
    window.initializeCollectionSwiper();
  }
});
